export default "__VITE_ASSET__Bd5hdh0___"